var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20.002,
    viewBox: "0 0 16 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_247975",
    "data-name": "Path 247975",
    d: "M380.446,373.923H372.06c.348-.548,1.545-2.873,1.885-9.313h4.681C378.624,365.083,378.637,370.348,380.446,373.923Z",
    transform: "translate(-368.233 -358.641)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247976",
    "data-name": "Path 247976",
    d: "M444.271,287.5c0,.183-.276.331-.615.331h-5.724c-.34,0-.615-.148-.615-.331s.276-.331.615-.331h5.724C443.995,287.168,444.271,287.316,444.271,287.5Z",
    transform: "translate(-432.795 -282.078)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247977",
    "data-name": "Path 247977",
    d: "M383.334,38.492v4.9H375.12v-4.9h1.547v1.356h1.905V38.492h1.27v1.356h1.9V38.492Z",
    transform: "translate(-371.227 -38.492)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247978",
    "data-name": "Path 247978",
    d: "M250.874,905.255H236.8c-.039-.627.092-1.337,1.286-1.506,1.058-.15,1.147-.852,1.15-1.056h9.185c.273,1.036.878,1.036.879,1.036,1.859.109,1.653,1.24,1.57,1.526Z",
    transform: "translate(-235.86 -887.223)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247979",
    "data-name": "Path 247979",
    d: "M208.949,1079.017l-.014,1.247H192.963l-.014-1.059a1.5,1.5,0,0,1,.636-.716h14.837a1.175,1.175,0,0,1,.526.528Z",
    transform: "translate(-192.949 -1060.262)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRook);
export default __webpack_public_path__ + "static/media/rook.2572d78b0b37a68564cf6c6a52506aa8.svg";
export { ForwardRef as ReactComponent };